import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import GigJobCard from '@/partials/GigCards/GigJobCard/GigJobCard.vue'

const GIGS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    GigJobCard,
    InfiniteLoading,
  },
  data() {
    return {
      anchor: '#gig-cards',
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState('myGigs', {
      isLoading: (state: any) => state.freelancerInProgressList.isLoading,
      isLoaded: (state: any) => state.freelancerInProgressList.isLoaded,
      pagination: (state: any) => state.freelancerInProgressList.pagination,
      gigs: (state: any) => state.freelancerInProgressList.values,
    }),
  },
  async created() {
    await this.load({ limit: GIGS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myGigs/getFreelancerInProgressOffersList',
      loadMore: 'myGigs/loadMoreFreelancerInProgressOffersList',
      refreshList: 'myGigs/refreshFreelancerInProgressOffersList',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.gigs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: GIGS_LIMIT, offset: this.gigs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
    onRefreshList() {
      this.refreshList()
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Gigs - In progress'),
    }
  },
})
